import {observer} from 'mobx-react';
import React from 'react';
import {CarouselItem} from 'reactstrap';
import Carousel from 'reactstrap/lib/Carousel';
import {CarouselStore} from '../../../../../lib/components/CarouselStore';
import {X9Content, X9ContentSnapshot} from '../../../../../domain';
import {ReactNodeGenerator} from '../../../../../lib/helpers';
import {X9ContentStateStore} from '../../common/X9ContentStateStore';
import {SlideModel, SlideShowModel} from '../models';
import {SlideShowStore} from './SlideShowStore';

function renderSlide(slide: SlideModel) {
  return (
    <div className="slideshow-slide">
      <div className="slideshow-image-container">
        <img className="slideshow-image" src={slide.imageUrl} alt="Image not found"/>
      </div>
    </div>);
}

function* renderSlides(model: SlideShowModel, store: CarouselStore): ReactNodeGenerator {
  for (let index = 0; index < model.slides.length; index++) {
    const slide = model.slides[index];
    yield (
      <CarouselItem key={index}
                    onExiting={store.setAnimatingTrue}
                    onExited={store.setAnimatingFalse}>
        {renderSlide(slide)}
      </CarouselItem>)
    ;
  }
}

@observer
class CarouselControls extends React.Component<{ store: CarouselStore }> {
  render() {
    const store = this.props.store;
    return (
      <div className="row justify-content-end">
        <div className="col-auto">
          <button type="button" className="btn btn-primary"
                  onClick={store.previous}
                  disabled={store.first || store.animating}>
            <i className="fa fa-caret-square-left"/> Previous
          </button>
          <button type="button" className="btn btn-primary"
                  onClick={store.next}
                  disabled={store.last || store.animating}>
            Next <i className="fa fa-caret-square-right"/>
          </button>
        </div>
      </div>);
  }
}

interface Props {
  x9: X9Content | X9ContentSnapshot,
  store: X9ContentStateStore,
  lessonType?: string | undefined
}

@observer
export class StudentSlideShow extends React.Component<Props> {
  readonly store: SlideShowStore;
  readonly lessonType: string | undefined;

  constructor(props: Readonly<Props>) {
    super(props);
    const model = JSON.parse(this.props.x9.Contents) as SlideShowModel;
    this.store = new SlideShowStore(props.x9.Id, model, props.store);
    this.lessonType = props.lessonType;
  }

  render() {
    const store = this.store;
    const lessonType = this.props.lessonType;
    const carousel = store.carousel;
    
    return (
      <>
        <div className="row">
          <div className="col">
            <div className="slideshow carousel-fade">
              <Carousel next={carousel.next}
                        previous={carousel.previous}
                        activeIndex={carousel.index}
                        interval={false}>
                {[Array.from(renderSlides(store.model, carousel))]}
              </Carousel>
            </div>
          </div>
        </div>

        {(lessonType !=='Standard' && lessonType !=='Demo') && <CarouselControls store={carousel}/>}
      </>
    );
  }

  componentWillUnmount() {
    this.store.dispose();
  }
}
